import { useCallback, useContext } from 'react';
import T from '../../../../../../common/components/T';
import UserContext from '../../../../../../common/utils/getContext';
import { dataSender } from '../../../../../../common/utils/router';
import { API_SERVER_URL, SITE_URL } from '../../../../../../common/utils/utils';
import css from './RecoverPass.module.scss';

const RecoverPass = () => {
    const { userToken, lang, setAlertData } = useContext(UserContext);

    const sender = useCallback(() => {
        dataSender(
            `${API_SERVER_URL}/api/v1/user/financial-password/recover`,
            'POST',
            { url: `${SITE_URL}/finpassword-reset` },
            (res) => {
                if (res?.data?.message) {
                    setAlertData({
                        type: 'success',
                        cont: res?.data?.message
                    });
                }
            },
            (error) => {
                if (error?.errors) {
                    setAlertData({
                        type: 'error',
                        cont: Object.values(error?.errors || {})
                            .map((errorArray) => errorArray.join('. '))
                            .join('. ')
                    });
                }
            },
            userToken,
            lang
        );
    }, [userToken, lang, setAlertData]);

    return (
        <p className={css.link}>
            <span>
                <T textName='forgot-password' defaultStr='Забыли пароль' />?
            </span>
            <span onClick={sender}>
                <T textName='restore' defaultStr='Восстановить' />
            </span>
        </p>
    );
};

export default RecoverPass;
